'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { LogIn, UserPlus, LogOut, User } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

export default function RoastRankAuthNav() {
  const { user, signOut, loading } = useAuth();
  const router = useRouter();
  const [signingOut, setSigningOut] = useState(false);

  const handleSignOut = async () => {
    setSigningOut(true);
    try {
      await signOut();
      router?.push('/roastrank');
    } catch {}
    setSigningOut(false);
  };

  if (loading) return null;

  if (user) {
    const displayName = user?.user_metadata?.full_name || user?.email?.split('@')?.[0] || 'Roaster';
    return (
      <div className="flex items-center gap-2">
        <Link href={`/roastrank/profile/${encodeURIComponent(displayName)}`}
          className="hidden sm:flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm font-semibold transition-all duration-200 hover:bg-white/5"
          style={{ color: 'var(--muted-foreground)' }}>
          <User size={14} />
          <span className="max-w-[100px] truncate">{displayName}</span>
        </Link>
        <button
          onClick={handleSignOut}
          disabled={signingOut}
          className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-semibold transition-all duration-200 hover:bg-white/5 disabled:opacity-50"
          style={{ color: 'var(--muted-foreground)' }}>
          <LogOut size={14} />
          <span className="hidden sm:inline">{signingOut ? 'Signing out…' : 'Sign Out'}</span>
        </button>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <Link href="/roastrank/login"
        className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-semibold transition-all duration-200 hover:bg-white/5"
        style={{ color: 'var(--muted-foreground)' }}>
        <LogIn size={14} />
        <span className="hidden sm:inline">Sign In</span>
      </Link>
      <Link href="/roastrank/signup"
        className="flex items-center gap-1.5 px-3 py-1.5 rounded-xl text-sm font-semibold transition-all duration-200 hover:scale-105"
        style={{ background: 'rgba(34,197,94,0.12)', color: 'var(--primary)', border: '1px solid rgba(34,197,94,0.25)' }}>
        <UserPlus size={14} />
        <span className="hidden sm:inline">Sign Up</span>
      </Link>
    </div>
  );
}
